import { Navigate } from "react-router-dom";
import { getLocalStorageData } from "./axiosComponent";

export const PrivateRoute = ({ children }) => {
  const auth = localStorage.getItem("accessToken");
  const userType = getLocalStorageData("profileDetails")?.["USER TYPE"];
  const previousPath = localStorage.getItem("previousPath") || "/";

  if (!auth) {
    return <Navigate to="/auth/sign-in" />;
  }

  if (userType === "WEB-USER") {
    return children;
  }

  return children;
};

export const StudentPrivateRoute = ({ children }) => {
  const auth = localStorage.getItem("studentAccessToken");
  const isStudent = getLocalStorageData("isStudent");
  const previousPath = localStorage.getItem("previousPath") || "/";
  if (!auth) {
    return <Navigate to="/auth/student/sign-in" />;
  }
  console.log("UT-STUDENT", isStudent);
  if (isStudent === "true") {
    return children;
  }

  return children;
};

export const CheckUserTypeRoute = ({ children }) => {
  const userType = getLocalStorageData("profileDetails")["USER TYPE"];

  if (userType === "ONBOARDING") {
    return <Navigate to="/onBoarding" replace />;
  }

  return children;
};

export const CheckIfUserIsOnBoarded = ({ children }) => {
  const userType = getLocalStorageData("profileDetails")["USER TYPE"];
  if (userType === "ONBOARDING") {
    console.log("userType feom check if user is onBoarded", userType);
    return children;
  }
  return <Navigate to="/auth/sign-in" />;
};
